import "core-js/modules/es.string.small.js";
import React from "react";
import { ButtonSizeEnum, ButtonVariantEnum, RaiseButton, RaiseColors, Typography } from "componentLibrary";
import { useStyles } from "./DrawerFooter.styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DrawerFooter = function DrawerFooter(_ref) {
  var cancelClickHandler = _ref.cancelClickHandler,
    submitClickHandler = _ref.submitClickHandler,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? true : _ref$isValid,
    _ref$submitCount = _ref.submitCount,
    submitCount = _ref$submitCount === void 0 ? 0 : _ref$submitCount,
    _ref$saveError = _ref.saveError,
    saveError = _ref$saveError === void 0 ? "" : _ref$saveError,
    _ref$submitLabel = _ref.submitLabel,
    submitLabel = _ref$submitLabel === void 0 ? "Save" : _ref$submitLabel,
    _ref$cancelLabel = _ref.cancelLabel,
    cancelLabel = _ref$cancelLabel === void 0 ? "Cancel" : _ref$cancelLabel,
    dataPendo = _ref["data-pendo"];
  var classes = useStyles();
  var errorTypography = function errorTypography(error) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_xsmall",
      color: RaiseColors.alarm,
      className: classes.errorText,
      children: error
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: classes.container,
    children: [/*#__PURE__*/_jsxs("div", {
      className: classes.errorContainer,
      children: [!isValid && submitCount > 0 ? errorTypography("Please correct form errors above.") : null, saveError ? errorTypography(saveError) : null]
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.buttonContainer,
      children: [/*#__PURE__*/_jsx(RaiseButton, {
        variant: ButtonVariantEnum.text,
        size: ButtonSizeEnum.small,
        onClick: cancelClickHandler,
        disabled: disabled,
        "data-pendo": dataPendo ? "".concat(dataPendo, "-cancel") : undefined,
        children: cancelLabel
      }), /*#__PURE__*/_jsx(RaiseButton, {
        variant: ButtonVariantEnum.primary,
        size: ButtonSizeEnum.small,
        onClick: submitClickHandler,
        disabled: loading || disabled,
        "data-pendo": dataPendo ? "".concat(dataPendo, "-submit") : undefined,
        children: submitLabel
      })]
    })]
  });
};
export default DrawerFooter;